import {degreeMap} from './constants';

const isEmpty = obj => {
  return Object.keys(obj).length === 0;
};

export const mapToDisplay = res => {
  if(!res.data||isEmpty(res.data)) {
    return {data:[]};
  }
  else{
    let mdata = [];
    res.data.modules?.forEach(module =>{
      let mobj = {};
      mobj.dheader = module.module_name;
      mobj.majors = [];
      module.question_groups?.forEach(qg =>{
        qg.questions?.forEach(q=>{
            const qtarr = q.question_text.split('-');
            const newQt = qtarr[1].trim()+' - '+qtarr[0].trim();
            const question = {name: newQt, qid: `${res.data.id}_${module.id}_${qg.id}_${q.id}`};
            mobj.majors.push(question);
        });
      });
      mdata.push(mobj);
    });
    return {data:mdata};
  }
};

export const lastUpdateFromModule = res => {
  if(!res.data||isEmpty(res.data)) {
    return null;
  }
  else{
    const lastUpdateModule =  res.data[0].modules?.reduce((acc, module) => {
      acc = ( acc === undefined || module.last_updated_at > acc.last_updated_at ) ? module : acc;
      return acc;
    });
    return lastUpdateModule.last_updated_at;
  }
};

export const mapToTotalMajors = res => {
  if(!res.data||isEmpty(res.data)) {
    return [];
  }
  else{

    let rtnData = [];
    res.data[0].modules?.forEach(module =>{
      let mo = {};
      
      let majors = [];
      module.question_groups?.forEach(qg =>{
        qg.questions?.forEach(q=>{
            let mobj= {};
            const qtarr = q.question_text.split('-');
            const newQt = qtarr[1].trim()+' - '+qtarr[0].trim();
            mobj['name'] = newQt;
            mobj['boxChecked'] = true;
            const answer = q.current_value?q.current_value.split('|'):[];
            mobj['qid'] = `${res.data[0].id}_${module.id}_${qg.id}_${q.id}`, 
            mobj['degrees'] = totalMajorsDegreesMapping([...answer]), 
            mobj['new'] = false, 
            mobj['modified'] = false;
            majors.push(mobj);
        });
      });
      mo[module.module_name]=[...majors];
      
      rtnData.push(mo);
    });
    return rtnData;
  }
};

export const degreesSum = arr => {
  let firstdegree = true, seconddegree = true, thirddegree = true, forthdegree = true, fifthdegree = true, sixthdegree = true;
  for(const mj of arr){
    firstdegree = firstdegree&&mj.degrees[2];
    seconddegree = seconddegree&&mj.degrees[3];
    thirddegree  = thirddegree&&mj.degrees[4];
    forthdegree  = forthdegree&&mj.degrees[5];
    fifthdegree  = fifthdegree&&mj.degrees[6];
    sixthdegree  = sixthdegree&&mj.degrees[7];
  }
  return [false, false, firstdegree, seconddegree, thirddegree, forthdegree, fifthdegree, sixthdegree, false];
};

const totalMajorsDegreesMapping = answers => {
  //answers: ['cert', 'doc'], need return [true, null, true, null, null, null, true, null, null]
  let rtnobj = [true, null, null, null, null, null, null, null, null];
  answers.forEach(a => {
    for (const key of Object.keys(degreeMap)) {
      if(degreeMap[key]===a)
      {
        rtnobj[key] = true;
        break;
      }
    }
  });
  return rtnobj;
};

export const formatSavePayload = (qid, degrees, is_selected) => {
  //{id: 370, category_id: 5, module_id: 15, question_group_id: 69, current_value: "123"}
  //degrees: [true, true, true, null, null, true, true, null, null] only care 2-8
  const qarr = qid.split('_');
  const category_id = parseInt(qarr[0]);
  //const category_id = qarr[0]; //error case
  const module_id = parseInt(qarr[1]);
  const question_group_id = parseInt(qarr[2]);
  const id = parseInt(qarr[3]);

  let current_value='';
  for(let i=2; i<9; i++){
    if(degrees[i]===true){
      current_value+=degreeMap[i];
      current_value+='|';
    }
  }
  current_value = current_value.substring(0, current_value.length-1);
  return {id, category_id, module_id, question_group_id, current_value, is_selected};
};

